import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 51,
	viewBox: "0 0 51 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M42.2939 18.2453C42.1931 18.0146 42.0521 17.8038 41.8774 17.6226L29.1274 4.87262C28.9462 4.69791 28.7354 4.55687 28.5047 4.45612C28.441 4.42637 28.373 4.40937 28.305 4.386C28.1272 4.32549 27.9421 4.28905 27.7546 4.27763C27.71 4.27338 27.6696 4.25 27.625 4.25H12.75C10.4061 4.25 8.5 6.15612 8.5 8.5V42.5C8.5 44.8439 10.4061 46.75 12.75 46.75H38.25C40.5939 46.75 42.5 44.8439 42.5 42.5V19.125C42.5 19.0804 42.4766 19.04 42.4724 18.9932C42.462 18.8056 42.4255 18.6204 42.364 18.4429C42.3428 18.3749 42.3236 18.309 42.2939 18.2453ZM35.2453 17H29.75V11.5048L35.2453 17ZM12.75 42.5V8.5H25.5V19.125C25.5 19.6886 25.7239 20.2291 26.1224 20.6276C26.5209 21.0261 27.0614 21.25 27.625 21.25H38.25L38.2543 42.5H12.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17 25.5H34V29.75H17V25.5ZM17 34H34V38.25H17V34ZM17 17H21.25V21.25H17V17Z",
		fill: "currentColor"
	})]
});
export default SvgFile;
